module.exports = __webpack_public_path__ + "img/prediction_delete.1b1dcdd4.png";